import { all_routes } from "../../../feature-module/router/all_routes";
import { route } from "../../common/selectoption/selectoption";
const routes = all_routes;

export const SidebarDataTest = [
  {
    tittle: "Main Menu",
    icon: "airplay",
    showAsTab: true,
    separateRoute: false,
    submenuItems: [
      {
        label: "Dashboard",
        link: routes.adminDashboard,
        submenu: true,
        showSubRoute: false,
        icon: "smart-home",
        base: "dashboard",
        materialicons: "start",
        dot: false,
        submenuItems: [
          { label: "Admin Dashboard", link: routes.adminDashboard },
        ],
      },
    ],
  },
  {
    tittle: "Master",
    icon: "file",
    showAsTab: false,
    separateRoute: false,
    submenuItems: [
      {
        label: "HRM & Payroll",
        link: routes.hrmOperations,
        submenu: false,
        showSubRoute: false,
        icon: "users-group",
        base: "hrm-operations",
        materialicons: "payments",
        submenuItems: [],
      },
      {
        label: "CRM Pipeline",
        link: routes.crmPipeline,
        submenu: false,
        showSubRoute: false,
        icon: "timeline-event",
        base: "crm-pipeline",
        materialicons: "leaderboard",
        submenuItems: [],
      },
      {
        label: "Emi Calculator",
        link: "performanceIndicator",
        submenu: true,
        showSubRoute: false,
        icon: "school",
        base: "performance",
        materialicons: "work_outline",
        submenuItems: [
          {
            label: "Emi Calculator",
            link: routes.emi_calculator,
            base: "indicator",
          },
        ],
      },
      {
        label: "Manage Users",
        link: routes.employeeList,
        submenu: true,
        showSubRoute: false,
        icon: "users",
        base: "employees",
        materialicons: "people",
        submenuItems: [
          {
            label: "Nationals",
            link: routes.employeeList,
            base: "employees",
            base2: "employee-list",
          },
          {
            label: "Super Distributors",
            link: routes.superDistributorList,
            base: "employees",
            base2: "employee-list",
          },
          {
            label: "Distributors",
            link: routes.distributorList,
            base: "employees",
            base2: "employee-list",
          },
        ],
      },
      {
        label: "Financer",
        link: "performanceIndicator",
        submenu: true,
        showSubRoute: false,
        icon: "school",
        base: "performance",
        materialicons: "work_outline",
        submenuItems: [
          {
            label: "Financers List",
            link: routes.financesListing,
            base: "indicator",
          },
        ],
      },
      {
        label: "Branches",
        link: "performanceIndicator",
        submenu: true,
        showSubRoute: false,
        icon: "school",
        base: "performance",
        materialicons: "work_outline",
        submenuItems: [
          {
            label: "Branches List",
            link: routes.retailerList,
            base: "indicator",
          },
        ],
      },
      {
        label: "Manage Staffs",
        link: "staffList",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "tickets",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: "Staff List",
            link: routes.staffList,
            base: "staff-list",
          },
        ],
      },
      {
        label: "Plans",
        link: "planList",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "tickets",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: "Plan List",
            link: routes.planList,
            base: "plans-list",
          },
        ],
      },
      {
        label: "Discounts",
        link: "discountList",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "tickets",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: "Discount List",
            link: routes.discountList,
            base: "discount-list",
          },
        ],
      },

      {
        label: "Vouchers",
        link: "voucherList",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "tickets",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: "Vouchers List",
            link: routes.voucherList,
            base: "voucher-list",
          },
        ],
      },
      {
        label: "Advertisement",
        link: "ticketList",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "tickets",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: "Advertisement List",
            link: routes.advertisementList,
            base: "pending-list",
          },
        ],
      },
      {
        label: "Cibil",
        link: "cibil",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "cibil",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: "Cibil Report",
            link: routes.cibil,
            base: "cibil",
          },
        ],
      },
      {
        label: "Cheques",
        link: "cheques",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "cheques",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: "Cheque List",
            link: routes.cheques,
            base: "cheques",
          },
        ],
      },
      {
        label: "Financer Data",
        link: "financerdata",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "financerdata",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: "Financer Data",
            link: routes.financerdata,
            base: "financerdata",
          },
        ],
      },
      {
        label: "Accounting",
        link: "expensesList",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "expensesList",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: "Expense List",
            link: routes.expensesList,
            base: "expense-list",
          },
          {
            label: "Approved Loan",
            link: routes.approve_loan,
            base: "approve-list",
          },
        ],
      },
    ],
  },
];

export const SideNationalDataTest = [
  {
    tittle: "Main Menu",
    icon: "airplay",
    showAsTab: true,
    separateRoute: false,
    submenuItems: [
      {
        label: "Dashboard",
        link: "index",
        submenu: true,
        showSubRoute: false,
        icon: "smart-home",
        base: "dashboard",
        materialicons: "start",
        dot: false,
        submenuItems: [
          { label: "Admin Dashboard", link: routes.adminDashboard },
        ],
      },
    ],
  },

  {
    tittle: "Master",
    icon: "file",
    showAsTab: false,
    separateRoute: false,
    submenuItems: [
      {
        label: "Emi Calculator",
        link: "performanceIndicator",
        submenu: true,
        showSubRoute: false,
        icon: "school",
        base: "performance",
        materialicons: "work_outline",
        submenuItems: [
          {
            label: "Emi Calculator",
            link: routes.emi_calculator,
            base: "indicator",
          },
        ],
      },
      {
        label: "Manage Users",
        link: routes.employeeList,
        submenu: true,
        showSubRoute: false,
        icon: "users",
        base: "employees",
        materialicons: "people",
        submenuItems: [
          {
            label: "Super Distributors",
            link: routes.superDistributorList,
            base: "employees",
            base2: "employee-list",
          },
          {
            label: "Distributors",
            link: routes.distributorList,
            base: "employees",
            base2: "employee-list",
          },
        ],
      },

      {
        label: "Financer",
        link: "performanceIndicator",
        submenu: true,
        showSubRoute: false,
        icon: "school",
        base: "performance",
        materialicons: "work_outline",
        submenuItems: [
          {
            label: "Financers List",
            link: routes.financesListing,
            base: "indicator",
          },
        ],
      },
      {
        label: "Branches",
        link: "performanceIndicator",
        submenu: true,
        showSubRoute: false,
        icon: "school",
        base: "performance",
        materialicons: "work_outline",
        submenuItems: [
          {
            label: "Branches List",
            link: routes.retailerList,
            base: "indicator",
          },
        ],
      },
      {
        label: "Manage Staffs",
        link: "staffList",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "tickets",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: "Staff List",
            link: routes.staffList,
            base: "staff-list",
          },
        ],
      },
      {
        label: "Visitors",
        link: "visitors",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "tickets",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: "Pending Visits List",
            link: routes.all_visitors,
            base: "all_visitors-list",
          },
          {
            label: "Regular List",
            link: "/regular-visitors",
            base: "all_visitors-list",
          },
          {
            label: "All Visited List",
            link: routes.visitedLists,
            base: "all_visited-list",
          },
          {
            label: "Super-Distributors List",
            link: routes.visitors,
            base: "visitors-list",
          },
          {
            label: "Distributors List",
            link: routes.visitors_dist,
            base: "visitors_dist",
          },
          {
            label: "Financers List",
            link: routes.visitors_financer,
            base: "visitors_financer",
          },
          {
            label: "Branches List",
            link: routes.visitors_retailer,
            base: "visitors_retailer",
          },
        ],
      },
      {
        label: "Advertisement",
        link: "ticketList",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "tickets",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: "Advertisement List",
            link: routes.advertisementList,
            base: "pending-list",
          },
        ],
      },
    ],
  },
];
export const SideSuperDistDataTest = [
  {
    tittle: "Main Menu",
    icon: "airplay",
    showAsTab: true,
    separateRoute: false,
    submenuItems: [
      {
        label: "Dashboard",
        link: "index",
        submenu: true,
        showSubRoute: false,
        icon: "smart-home",
        base: "dashboard",
        materialicons: "start",
        dot: false,
        submenuItems: [
          { label: "Admin Dashboard", link: routes.adminDashboard },
        ],
      },
    ],
  },

  {
    tittle: "Master",
    icon: "file",
    showAsTab: false,
    separateRoute: false,
    submenuItems: [
      {
        label: "Emi Calculator",
        link: "performanceIndicator",
        submenu: true,
        showSubRoute: false,
        icon: "school",
        base: "performance",
        materialicons: "work_outline",
        submenuItems: [
          {
            label: "Emi Calculator",
            link: routes.emi_calculator,
            base: "indicator",
          },
        ],
      },
      {
        label: "Manage Users",
        link: routes.employeeList,
        submenu: true,
        showSubRoute: false,
        icon: "users",
        base: "employees",
        materialicons: "people",
        submenuItems: [
          {
            label: "Distributors",
            link: routes.distributorList,
            base: "employees",
            base2: "employee-list",
          },
        ],
      },

      {
        label: "Financer",
        link: "performanceIndicator",
        submenu: true,
        showSubRoute: false,
        icon: "school",
        base: "performance",
        materialicons: "work_outline",
        submenuItems: [
          {
            label: "Financers List",
            link: routes.financesListing,
            base: "indicator",
          },
        ],
      },
      {
        label: "Branches",
        link: "performanceIndicator",
        submenu: true,
        showSubRoute: false,
        icon: "school",
        base: "performance",
        materialicons: "work_outline",
        submenuItems: [
          {
            label: "Branches List",
            link: routes.retailerList,
            base: "indicator",
          },
        ],
      },
      {
        label: "Manage Staffs",
        link: "staffList",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "tickets",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: "Staff List",
            link: routes.staffList,
            base: "staff-list",
          },
        ],
      },
      {
        label: "Visitors",
        link: "visitors",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "visitors",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: "Pending Visits List",
            link: routes.all_visitors,
            base: "all_visitors-list",
          },
          {
            label: "Regular List",
            link: "/regular-visitors",
            base: "all_visitors-list",
          },
          {
            label: "All Visited List",
            link: routes.visitedLists,
            base: "all_visited-list",
          },
          {
            label: "Distributors List",
            link: routes.visitors_dist,
            base: "visitors_dist",
          },
          {
            label: "Financers List",
            link: routes.visitors_financer,
            base: "visitors_financer",
          },
          {
            label: "Branches List",
            link: routes.visitors_retailer,
            base: "visitors_retailer",
          },
        ],
      },
    ],
  },
];
export const SideDistDataTest = [
  {
    tittle: "Main Menu",
    icon: "airplay",
    showAsTab: true,
    separateRoute: false,
    submenuItems: [
      {
        label: "Dashboard",
        link: "index",
        submenu: true,
        showSubRoute: false,
        icon: "smart-home",
        base: "dashboard",
        materialicons: "start",
        dot: false,
        submenuItems: [
          { label: "Admin Dashboard", link: routes.adminDashboard },
        ],
      },
    ],
  },

  {
    tittle: "Master",
    icon: "file",
    showAsTab: false,
    separateRoute: false,
    submenuItems: [
      {
        label: "Emi Calculator",
        link: "performanceIndicator",
        submenu: true,
        showSubRoute: false,
        icon: "school",
        base: "performance",
        materialicons: "work_outline",
        submenuItems: [
          {
            label: "Emi Calculator",
            link: routes.emi_calculator,
            base: "indicator",
          },
        ],
      },
      {
        label: "Financer",
        link: "performanceIndicator",
        submenu: true,
        showSubRoute: false,
        icon: "school",
        base: "performance",
        materialicons: "work_outline",
        submenuItems: [
          {
            label: "Financers List",
            link: routes.financesListing,
            base: "indicator",
          },
        ],
      },
      {
        label: "Branches",
        link: "performanceIndicator",
        submenu: true,
        showSubRoute: false,
        icon: "school",
        base: "performance",
        materialicons: "work_outline",
        submenuItems: [
          {
            label: "Branches List",
            link: routes.retailerList,
            base: "indicator",
          },
        ],
      },
      {
        label: "Manage Staffs",
        link: "staffList",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "tickets",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: "Staff List",
            link: routes.staffList,
            base: "staff-list",
          },
        ],
      },
      {
        label: "Visitors",
        link: "visitors",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "visitors",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: "Pending Visits List",
            link: routes.all_visitors,
            base: "all_visitors-list",
          },
          {
            label: "Regular List",
            link: "/regular-visitors",
            base: "all_visitors-list",
          },
          {
            label: "All Visited List",
            link: routes.visitedLists,
            base: "all_visited-list",
          },
          {
            label: "Financers List",
            link: routes.visitors_financer,
            base: "visitors_financer",
          },
          {
            label: "Branches List",
            link: routes.visitors_retailer,
            base: "visitors_retailer",
          },
        ],
      },
    ],
  },
];
export const SideFinanceDataTest = [
  {
    tittle: "Main Menu",
    icon: "airplay",
    showAsTab: true,
    separateRoute: false,
    submenuItems: [
      {
        label: "Dashboard",
        link: "index",
        submenu: true,
        showSubRoute: false,
        icon: "smart-home",
        base: "dashboard",
        materialicons: "start",
        dot: false,
        submenuItems: [
          { label: "Admin Dashboard", link: routes.employeeDashboard },
        ],
      },
    ],
  },

  {
    tittle: "Master",
    icon: "file",
    showAsTab: false,
    separateRoute: false,
    submenuItems: [
      {
        label: "HRM & Payroll",
        link: routes.hrmOperations,
        submenu: false,
        showSubRoute: false,
        icon: "users-group",
        base: "hrm-operations",
        materialicons: "payments",
        submenuItems: [],
      },
      {
        label: "CRM Pipeline",
        link: routes.crmPipeline,
        submenu: false,
        showSubRoute: false,
        icon: "timeline-event",
        base: "crm-pipeline",
        materialicons: "leaderboard",
        submenuItems: [],
      },
      {
        label: "Directors",
        link: "performanceIndicator",
        submenu: true,
        showSubRoute: false,
        icon: "users",
        base: "performance",
        materialicons: "work_outline",
        submenuItems: [
          {
            label: "Directors List",
            link: routes.directorList,
            base: "indicator",
          },
        ],
      },
      {
        label: "Emi Calculator",
        link: "performanceIndicator",
        submenu: true,
        showSubRoute: false,
        icon: "school",
        base: "performance",
        materialicons: "work_outline",
        submenuItems: [
          {
            label: "Emi Calculator",
            link: routes.emi_calculator,
            base: "indicator",
          },
        ],
      },
      {
        label: "Branches",
        link: "performanceIndicator",
        submenu: true,
        showSubRoute: false,
        icon: "school",
        base: "performance",
        materialicons: "work_outline",
        submenuItems: [
          {
            label: "Branches List",
            link: routes.retailerList,
            base: "indicator",
          },
        ],
      },
      {
        label: "Customers",
        link: "performanceIndicator",
        submenu: true,
        showSubRoute: false,
        icon: "school",
        base: "performance",
        materialicons: "work_outline",
        submenuItems: [
          {
            label: "Customer List",
            link: routes.customerList,
            base: "review",
          },
          {
            label: "Customer Allocation",
            link: routes.customer_allocation,
            base: "customer-allocation",
          },
        ],
      },

      {
        label: "Product",
        link: "productList",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "tickets",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: "Product List",
            link: routes.productList,
            base: "plans-list",
          },
          {
            label: "Product Name List",
            link: routes.productNameList,
            base: "plans-list",
          },
        ],
      },
      // {
      //   label: "Visitors",
      //   link: "visitors",
      //   submenu: true,
      //   showSubRoute: false,
      //   icon: "ticket",
      //   base: "visitors",
      //   materialicons: "leaderboard",
      //   submenuItems: [
      //     {
      //       label: "All Visitors List",
      //       link: routes.all_visitors,
      //       base: "all_visitors-list",
      //     },
      //     {
      //       label: "All Visited List",
      //       link: routes.visitedLists,
      //       base: "all_visited-list",
      //     },

      //     {
      //       label: "Branches List",
      //       link: routes.visitors_retailer,
      //       base: "visitors_retailer",
      //     },
      //   ],
      // },
      {
        label: "Verification",
        link: "verificationList",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "verificationList",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: "verification",
            link: routes.verificationList,
            base: "verificationList",
          },
          {
            label: " Verification Status",
            link: routes.secondverificationlist,
            base: "secondverificationlist",
          },
        ],
      },
      {
        label: "Manage Staffs",
        link: "staffList",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "tickets",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: "Staff List",
            link: routes.staffList,
            base: "staff-list",
          },
        ],
      },
      {
        label: "Emi Records",
        link: "pendingEmiList",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "pendingEmiList",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: "emi records",
            link: routes.pendingEmiList,
            base: "pending-list",
          },
        ],
      },
      {
        label: "Cibil",
        link: "cibil",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "cibil",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: "Cibil Report",
            link: routes.cibil,
            base: "cibil",
          },
        ],
      },
      {
        label: "Collection",
        link: "collection",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "Collection",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: "Payments Collections",
            link: routes.paymentcollection,
            base: "Payments-list",
          },
          {
            label: "Emi Details",
            link: routes.emidetails,
            base: "Emi-list",
          },
        ],
      },
      {
        label: "Loan Status",
        link: "loanstatus",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "loanstatus",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: "Loan Status",
            link: routes.loanstatus,
            base: "Loan-list",
          },
        ],
      },

      {
        label: "Advertisement",
        link: "ticketList",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "tickets",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: "Advertisement List",
            link: routes.advertisementList,
            base: "pending-list",
          },
        ],
      },
      {
        label: "Accounting",
        link: "expensesList",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "expensesList",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: "Expense List",
            link: routes.expensesList,
            base: "expense-list",
          },
          {
            label: "CashBook",
            link: routes.cash_list,
            base: "cash-list",
          },
          {
            label: "BankBook",
            link: routes.bank_list,
            base: "bank-list",
          },

          {
            label: "Approved Loan",
            link: routes.approve_loan,
            base: "approve-list",
          },
          {
            label: "Disbursement Loan",
            link: routes.disbursement_loan,
            base: "disbursement-list",
          },
          {
            label: "Payments",
            link: routes.payments_approved,
            base: "payments-list",
          },
          {
            label: "Company Statements",
            link: routes.company_statement,
            base: "company-statement-list",
          },
          {
            label: "NPA & DPD Dashboard",
            link: routes.npa_dashboard,
            base: "npa-dashboard",
          },
        ],
      },
      {
        label: "Aadhaar Services",
        link: "aadharServiceLogs",
        submenu: true,
        showSubRoute: false,
        icon: "id",
        base: "aadhar-service-logs",
        materialicons: "badge",
        submenuItems: [
          {
            label: "Service Logs",
            link: routes.aadharServiceLogs,
            base: "aadhar-service-logs",
          },
        ],
      },
    ],
  },
];
export const SideRetailerDataTest = [
  {
    // tittle: "Main Menu",
    icon: "airplay",
    showAsTab: true,
    separateRoute: false,
  },

  {
    tittle: "Master",
    icon: "file",
    showAsTab: false,
    separateRoute: false,
    submenuItems: [
      {
        label: "HRM & Payroll",
        link: routes.hrmOperations,
        submenu: false,
        showSubRoute: false,
        icon: "users-group",
        base: "hrm-operations",
        materialicons: "payments",
        submenuItems: [],
      },
      {
        label: "CRM Pipeline",
        link: routes.crmPipeline,
        submenu: false,
        showSubRoute: false,
        icon: "timeline-event",
        base: "crm-pipeline",
        materialicons: "leaderboard",
        submenuItems: [],
      },
      {
        label: "Emi Calculator",
        link: "performanceIndicator",
        submenu: true,
        showSubRoute: false,
        icon: "school",
        base: "performance",
        materialicons: "work_outline",
        submenuItems: [
          {
            label: "Emi Calculator",
            link: routes.emi_calculator,
            base: "indicator",
          },
        ],
      },
      {
        label: "Customers",
        link: "performanceIndicator",
        submenu: true,
        showSubRoute: false,
        icon: "school",
        base: "performance",
        materialicons: "work_outline",
        submenuItems: [
          // { label: "Admin Dashboard", link: routes.adminDashboard },
          {
            label: "Apply Loan",
            link: routes.applyform,
            base: "review",
          },
          {
            label: "Customer List",
            link: routes.customerList,
            base: "review",
          },
        ],
      },

      {
        label: "Manage Staffs",
        link: "staffList",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "tickets",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: "Staff List",
            link: routes.staffList,
            base: "staff-list",
          },
        ],
      },

      {
        label: "Emi Records",
        link: "ticketList",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "tickets",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: "pending emis",
            link: routes.pendingEmiList,
            base: "pending-list",
          },
        ],
      },
      {
        label: "Cibil",
        link: "cibil",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "cibil",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: "Cibil Report",
            link: routes.cibil,
            base: "cibil",
          },
        ],
      },
      {
        label: "Accounting",
        link: "expensesList",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "expensesList",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: "Disbursement Loan",
            link: routes.disbursement_loan,
            base: "disbursement-list",
          },
          {
            label: "NPA & DPD Dashboard",
            link: routes.npa_dashboard,
            base: "npa-dashboard",
          },
        ],
      },
    ],
  },
];

export const SideEmployeeDataTest = [
  {
    tittle: "Master",
    icon: "file",
    showAsTab: false,
    separateRoute: false,
    submenuItems: [
      {
        label: "Emi Calculator",
        link: "performanceIndicator",
        submenu: true,
        showSubRoute: false,
        icon: "school",
        base: "performance",
        materialicons: "work_outline",
        submenuItems: [
          {
            label: "Emi Calculator",
            link: routes.emi_calculator,
            base: "indicator",
          },
        ],
      },
      {
        label: "Branches",
        link: "performanceIndicator",
        submenu: true,
        showSubRoute: false,
        icon: "school",
        base: "performance",
        materialicons: "work_outline",
        submenuItems: [
          {
            label: "Branches List",
            link: routes.retailerList,
            base: "indicator",
          },
        ],
      },
      {
        label: "Customers",
        link: "performanceIndicator",
        submenu: true,
        showSubRoute: false,
        icon: "school",
        base: "performance",
        materialicons: "work_outline",
        submenuItems: [
          {
            label: "Apply Loan",
            link: routes.applyform,
            base: "review",
          },
          {
            label: "Customer List",
            link: routes.customerList,
            base: "review",
          },
        ],
      },
      // {
      //   label: "Apply Loan",
      //   link: "performanceIndicator",
      //   submenu: true,
      //   showSubRoute: false,
      //   icon: "school",
      //   base: "performance",
      //   materialicons: "work_outline",
      //   submenuItems: [
      //     {
      //       label: "Apply Loan",
      //       link: routes.applyform,
      //       base: "review",
      //     },
      //   ],
      // },

      {
        label: "Product",
        link: "productList",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "tickets",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: "Product List",
            link: routes.productList,
            base: "plans-list",
          },
        ],
      },
      {
        label: "Manage Users",
        link: routes.employeeList,
        submenu: true,
        showSubRoute: false,
        icon: "users",
        base: "employees",
        materialicons: "people",
        submenuItems: [
          {
            label: "Super Distributors",
            link: routes.superDistributorList,
            base: "employees",
            base2: "employee-list",
          },
          {
            label: "Distributors",
            link: routes.distributorList,
            base: "employees",
            base2: "employee-list",
          },
        ],
      },
      {
        label: "Financer",
        link: "performanceIndicator",
        submenu: true,
        showSubRoute: false,
        icon: "school",
        base: "performance",
        materialicons: "work_outline",
        submenuItems: [
          {
            label: "Financers List",
            link: routes.financesListing,
            base: "indicator",
          },
        ],
      },
      {
        label: "Visitors",
        link: "visitors",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "visitors",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: "All Visitors List",
            link: routes.all_visitors,
            base: "all_visitors-list",
          },
          {
            label: "All Visited List",
            link: routes.visitedLists,
            base: "all_visited-list",
          },

          {
            label: "Financers List",
            link: routes.visitors_financer,
            base: "visitors_financer",
          },
          {
            label: "Branches List",
            link: routes.visitors_retailer,
            base: "visitors_retailer",
          },
        ],
      },

      {
        label: "Manage Staffs",
        link: "staffList",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "tickets",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: "Staff List",
            link: routes.staffList,
            base: "staff-list",
          },
        ],
      },

      {
        label: "Collection",
        link: "collection",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "Collection",
        materialicons: "leaderboard",
        submenuItems: [
          // {
          //   label: "Payments Collections",
          //   link: routes.paymentcollection,
          //   base: "Payments-list",
          // },
          {
            label: "Emi Details",
            link: routes.emidetails,
            base: "Emi-list",
          },
        ],
      },
      {
        label: "Loan Status",
        link: "loanstatus",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "loanstatus",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: "Loan Status",
            link: routes.loanstatus,
            base: "Loan-list",
          },
        ],
      },
      {
        label: "Emi Records",
        link: "ticketList",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "tickets",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: "pending emis",
            link: routes.pendingEmiList,
            base: "pending-list",
          },
        ],
      },
      {
        label: "NPA & DPD Dashboard",
        link: "npaDashboard",
        alwaysVisibleForEmployee: true,
        submenu: true,
        showSubRoute: false,
        icon: "chart-bar",
        base: "npa-dashboard",
        materialicons: "monitoring",
        submenuItems: [
          {
            label: "NPA & DPD Dashboard",
            link: routes.npa_dashboard,
            base: "npa-dashboard",
          },
        ],
      },
      {
        label: "Cibil",
        link: "cibil",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "cibil",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: "Cibil Report",
            link: routes.cibil,
            base: "cibil",
          },
        ],
      },
      {
        label: "Advertisement",
        link: "ticketList",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "tickets",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: "Advertisement List",
            link: routes.advertisementList,
            base: "pending-list",
          },
        ],
      },
      {
        label: "Verification",
        link: "verificationList",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "verificationList",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: " Verification Status",
            link: routes.secondverificationlist,
            base: "secondverificationlist",
          },
        ],
      },
      {
        label: "Accounting",
        link: "expensesList",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "expensesList",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: "CashBook",
            link: routes.cash_list,
            base: "cash-list",
          },
          {
            label: "BankBook",
            link: routes.bank_list,
            base: "bank-list",
          },
          {
            label: "Expense List",
            link: routes.expensesList,
            base: "expense-list",
          },
          {
            label: "Disbursement Loan",
            link: routes.disbursement_loan,
            base: "disbursement-list",
          },
        ],
      },
    ],
  },
];

export const SideCustomerData = [
  {
    tittle: "Master",
    icon: "file",
    showAsTab: false,
    separateRoute: false,
    submenuItems: [
      {
        label: "Emi Calculator",
        link: "performanceIndicator",
        submenu: true,
        showSubRoute: false,
        icon: "school",
        base: "performance",
        materialicons: "work_outline",
        submenuItems: [
          {
            label: "Emi Calculator",
            link: routes.emi_calculator,
            base: "indicator",
          },
        ],
      },

      {
        label: "Customers",
        link: "performanceIndicator",
        submenu: true,
        showSubRoute: false,
        icon: "school",
        base: "performance",
        materialicons: "work_outline",
        submenuItems: [
          {
            label: "Customer List",
            link: routes.customerList,
            base: "review",
          },
        ],
      },
      {
        label: "Emi Records",
        link: "ticketList",
        submenu: true,
        showSubRoute: false,
        icon: "ticket",
        base: "tickets",
        materialicons: "leaderboard",
        submenuItems: [
          {
            label: "Emi Record",
            link: routes.pendingEmiList,
            base: "pending-list",
          },
        ],
      },
    ],
  },
];

const evLoanMenu = {
  label: "EV Vehicle Loans",
  link: routes.evCustomers,
  submenu: true,
  showSubRoute: false,
  icon: "car",
  base: "ev-loans",
  materialicons: "directions_car",
  alwaysVisibleForEmployee: true,
  submenuItems: [
    { label: "Apply EV Loan", link: routes.evApply },
    { label: "Customers", link: routes.evCustomers },
    { label: "Loan Products", link: routes.evProducts },
    { label: "Customer Loans", link: routes.evCustomerLoans },
    { label: "Disbursements", link: routes.evDisbursements },
    { label: "EMI Collections", link: routes.evCollections },
    { label: "EMI Details", link: routes.evEmiDetails },
  ],
};

for (const menu of [SideFinanceDataTest, SideRetailerDataTest, SideEmployeeDataTest] as any[][]) {
  const master = menu.find((section) => section.tittle === "Master");
  if (master?.submenuItems) master.submenuItems.push(evLoanMenu);
}
